import { EReputationMatchResult } from "src/core/types/entity";

type WatchlistSectionProps = {
  selectedMatch: EReputationMatchResult;
};

export const WatchlistSection = ({ selectedMatch }: WatchlistSectionProps) => {
  if (!selectedMatch?.detail?.watchlist?.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2 px-10 font-light">
      {selectedMatch?.detail?.watchlist?.map((w, idx) => (
        <span
          key={`watch-${idx}-${w.description}`}
          className="self-start inline-block bg-alert text-white px-3 py-1 rounded-lg border border-border"
          title={w.description}
        >
          {w.description}
        </span>
      ))}
    </div>
  );
};
